// Sentry init must run before any other lexportal module so the SDK is
// ready when React mounts. See ai-docs/sentry-integration-guide.md §3.
import "./sentry";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { installGlobalCapture } from "./lib/client-log";
import "./index.css";

// Restore theme from localStorage before first paint
const stored = localStorage.getItem("theme");
if (stored === "dark" || (!stored && matchMedia("(prefers-color-scheme: dark)").matches)) {
  document.documentElement.classList.add("dark");
}

// Wire window.onerror + unhandledrejection → operationalLogs collection
// via /api/client-log so platform admins see SPA-side errors that
// otherwise live only in the user's browser console.
installGlobalCapture();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
